/** Rewrite ImageKit's blocked delivery hostname while preserving the rest of the URL. */
export function normalizeImageKitUrl(value: string): string {
  try {
    const parsed = new URL(value);
    if (parsed.hostname !== 'ik.imagekit.io') return value;

    return value.replace(
      /^(\w[\w+.-]*:\/\/(?:[^/?#@]*@)?)(ik\.imagekit\.io)(?=[:/?#]|$)/i,
      '$1ik.imgkit.net',
    );
  } catch {
    return value;
  }
}
